import { message } from 'antd'
import { useCallback, useState } from 'react'
import * as Sentry from '@sentry/react'
import Container, { storeUtil } from '../Context'
import { createFeedback, uploadTos3 } from '../services'
import sentryCollection from '../utils/sentry'
import { useTranslation } from './useI18n'

export function useSubmit() {
  const [loading, setLoading] = useState(false)
  const { form, events, config, reset, type, time } = Container.useContainer()
  const { t } = useTranslation()
  const submit = useCallback(async () => {
    try {
      setLoading(true)
      Sentry.captureMessage('feedback trace')
      const formValue = await form.validateFields()

      let replay_url

      if (events?.length) {
        replay_url = await uploadTos3({
          events,
          appId: config?.current?.appId,
        })
      }

      const event_id = sentryCollection.sentryEvents || []
      const sentry_message_id = sentryCollection.messageId || ''

      const values = {
        ...formValue,
        replay_url,
        uid: config.current?.uid,
        country_code: config.current?.countryCode,
        app_id: config.current?.appId,
        report_type: type,
        event_id: event_id.length ? event_id.join(',') : undefined,
        sentry_message_id,
        username: config.current?.username,
        seller_id: config.current?.sellerId,
        ...time,
      }

      storeUtil.set({
        checkbox: 1,
      })

      await createFeedback(values)

      message.success(t('feedback.success'))
      reset()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }, [config, events, form, reset, t, time, type])

  return {
    loading,
    submit,
  }
}
